import { Icon } from "@blueprintjs/core"
import CustomReactTable from "components/Templates/CustomReactTable"
import dayjs from "dayjs"
import { useAllProductionBatchesQuery } from "generated/graphql"
import { useSearchFilter } from "hooks/searchFilterHooks"
import React from "react"
import { useFilter } from "store/search-filter/search-filter.reducer"
import UploaderHeader from "./UploaderHeader"

const PAGE_SIZE = 10
export const QCBatchUploader = () => {
  const [{ search, page }] = useSearchFilter()
  const [filter] = useFilter("production-batch-uploader")

  const { data, loading, refetch } = useAllProductionBatchesQuery({
    variables: {
      search: search || "",
      first: PAGE_SIZE,
      skip: page * PAGE_SIZE,
      dateFrom: filter?.dateRange?.[0],
      dateTo: filter?.dateRange?.[1],
      varietyId: filter?.variety?.id,
      isActive:
        filter?.active?.id === "no"
          ? false
          : filter?.active?.id === "yes"
          ? true
          : undefined,
    },
  })
  const items = data?.allProductionBatches
  const COLUMNS = [
    {
      Header: "Created On",
      accessor: "date",
      Cell({ value }) {
        if (!value) return "--"
        return (
          <div className="flex flex-col">
            <div>{dayjs(value).format("DD MMM 'YY")}</div>
          </div>
        )
      },
    },
    {
      Header: "Batch Name",
      accessor: "name",
      Cell({ value }) {
        if (!value) return "--"
        return <div>{value}</div>
      },
    },
    {
      Header: "Fruit/ Veg.",
      accessor: "variety.name",
      Cell({ value }) {
        if (!value) return "--"
        return <div>{value}</div>
      },
    },
    {
      Header: "Description",
      accessor: "description",
      Cell({ value }) {
        if (!value) return "--"
        return <div>{value}</div>
      },
    },
    {
      Header: "Is Active",
      accessor: "isActive",
      Cell({ value }) {
        return (
          <div>
            {value ? (
              <Icon className="" icon={"endorsed"} intent={"success"} />
            ) : (
              <Icon className="" icon={"cross-circle"} intent={"danger"} />
            )}
          </div>
        )
      },
    },
  ]
  return (
    <>
      <UploaderHeader refetch={refetch}>
        <CustomReactTable
          columns={COLUMNS}
          data={items}
          loading={loading}
          loadingText="Fetching Items"
          pageSize={items?.length > 15 ? items?.length : 15}
        />
      </UploaderHeader>
    </>
  )
}
